<template>
  <Bar
    :chart-options="option"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    option() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            max: this.setLimitY * 2 || 10,
          },
        },
      };
    },
    setLimitY() {
      let max = 0;
      if (this.chartData?.datasets?.length) {
        this.chartData.datasets.forEach((item) => {
          if (max < Math.max(...item.data)) max = Math.max(...item.data);
        });
      }
      return max;
    },
  },
};
</script>
